import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Controller } from "react-hook-form";
import useService from "../../Hooks/useService";
import FinanceService from "../../../Services/FinanceService.service";
import useUniqueId from "../../Hooks/useUniqueId";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
const UpdateFundingSourceForm = (props) => {
    const makeId = useUniqueId()[1];
    const [fundingSourcesState, loadFundingSources] = useService(FinanceService.getAllFundingSources);
    React.useEffect(() => {
        loadFundingSources();
    }, [loadFundingSources]);
    return (_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("funding-sources"), children: "Funding Sources" }), _jsx(Controller, { as: _jsx(DeprecatedSelect, { "aria-label": "Funding Sources", id: makeId("funding-sources"), options: fundingSourcesState.data || [], valueKey: "id", labelKey: "name", isLoading: fundingSourcesState.isLoading, multi: true, clearable: false }), name: "fundingSources", control: props.control })] }));
};
export default UpdateFundingSourceForm;
